module.exports = {
  EaseChat: require("./EaseChat/chat/index")["default"],
  EaseApp: require("./EaseApp/index")["default"]
};